import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .update-phone-modal {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .update-phone-modal-inputs {
    width: 100%;
    padding-bottom: 16px;
  }
  .phone-modal-wrapper,
  .reason-selector-wrapper {
    margin-bottom: 8px;
  }
  .update-phone-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .update-phone-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
